import {
  Hammer, Fan, Zap, Sparkles, Trees, ShieldCheck, ClipboardCheck, Leaf, Droplets, KeyRound, PanelTop, Waves, DoorOpen,
  Wrench, Siren, Moon, CalendarCheck, Building2, LayoutDashboard, CloudLightning, Flame, Layers, Home, Warehouse,
  GraduationCap, HeartPulse, Landmark, Store, BadgeCheck, Activity, FileCheck, Receipt, History,
} from "lucide-react";

const MAP = {
  Hammer, Fan, Zap, Sparkles, Trees, ShieldCheck, ClipboardCheck, Leaf, Droplets, KeyRound, PanelTop, Waves, DoorOpen,
  Wrench, Siren, Moon, CalendarCheck, Building2, LayoutDashboard, CloudLightning, Flame, Layers, Home, Warehouse,
  GraduationCap, HeartPulse, Landmark, Store, BadgeCheck, Activity, FileCheck, Receipt, History,
};

export const Icon = ({ name, className = "h-6 w-6" }) => {
  const C = MAP[name] || Sparkles;
  return <C className={className} aria-hidden="true" strokeWidth={1.5} />;
};
